export enum eSubscriptionCreationStatus {
  ALREADY_SUBSCRIBED = 'subscription already active',
}

export enum ePlanFrequency {
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  BIANNUAL = 'Biannual',
  ANNUALLY = 'Annually',
  WEEKLY = 'UniqueWeek',
  TRIAL = 'TRIAL',
}

export enum eSubscriptionStatus {
  TRIAL = 'TRIAL',
  ACTIVE = 'ACTIVE',
  PAST_DUE = 'PAST_DUE',
  NO_PAID = 'NO_PAID',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  SCHEDULED_CANCELLATION = 'SCHEDULED_CANCELLATION',
  PAUSED = 'PAUSED',
  INACTIVE = 'INACTIVE',
}

export enum eBillingNotificationType {
  PAST_DUE = 'past_due',
  TRIAL_CONFIRMATION = 'prompt_trial_confirmation',
}

export enum eSubscription {
  LEGACY = 'Legacy',
  BUSINESS = 'Business',
  GROWTH = 'Growth',
  ADVANCED = 'Advanced',
  OFFER = 'Offer',
  TIERS = 'TIERS',
}

export enum ePeriod {
  MONTHLY = 'Monthly',
  QUARTERLY = 'Quarterly',
  BIANNUAL = 'Biannual',
  ANNUALLY = 'Annually',
}

export enum eSubscriptionFeatureCode {
  ACTIVE_LEADS_LIMIT = 'active_leads_limit',
  AGENDA_MANAGEMENT_ACCESS = 'agenda_management_access',
  AUTO_REPLIES_ACCESS = 'auto_replies_access',
  BULK_MESSAGES_ACCESS = 'bulk_messages_access',
  CAMPAIGN_ANALYTICS_ACCESS = 'campaign_analytics_access',
  DIRECTORY_CONTACTS_ACCESS = 'directory_contacts_access',
  FACEBOOK_INTEGRATION_ACCESS = 'facebook_integration_access',
  FUNNELS_CREATION_LIMIT = 'funnels_creation_limit',
  HELP_CENTER_ACCESS = 'help_center_access',
  INSTAGRAM_INTEGRATION_ACCESS = 'instagram_integration_access',
  LEADBOT_LEVELS_ACCESS = 'leadbot_levels_access',
  LEADBOT_NEW_LEADS_ACCESS = 'leadbot_new_leads_access',
  LEADBOT_WATERMARK_REMOVAL = 'leadbot_watermark_removal',
  LIVE_SUPPORT_ACCESS = 'live_support_access',
  MARKETING_MESSAGE_VOLUME_LIMIT = 'marketing_message_volume_limit',
  NEW_WHATSAPP_NUMBER_ELIGIBILITY = 'new_whatsapp_number_eligibility',
  REACTIVATION_MESSAGES_LIMIT = 'reactivation_messages_limit',
  STORAGE_CAPACITY_GB = 'storage_capacity_gb',
  SYNC_CONTACTS_LIMIT = 'sync_contacts_limit',
  TEMPLATE_CREDITS_LIMIT = 'template_credits_limit',
  WEEKEND_SUPPORT_PROGRAM_ACCESS = 'weekend_support_program_access',
  WHATSAPP_API_ACCESS = 'whatsapp_api_access',
  WHATSAPP_API_WATERMARK_REMOVAL = 'whatsapp_api_watermark_removal',
  WHATSAPP_API_INTERACTIVE_CUSTOM_FOOTER = 'whatsapp_api_interactive_custom_footer',
  WHATSAPP_COEX_INTEGRATION = 'whatsapp_coex_integration',
  WHATSAPP_LEGACY_ACCESS = 'whatsapp_legacy_access',
  WHATSAPP_CAMPAIGN_ANALYTICS_ACCESS = 'whatsapp_campaign_analytics_access',
  API_KEY = 'apikey',
  CHAT_BOT = 'chatbot',
}

export enum ePlanCode {
  PLAN_LEGACY = 'PLAN_LEGACY',
  PLAN_BASIC = 'PLAN_BASIC',
  PLAN_PROFESSIONAL = 'PLAN_PROFESSIONAL',
  PLAN_ENTERPRISE = 'PLAN_ADVANCED',
}
